export default "__VITE_ASSET__CxBdTyDT__"